import { Button, Snackbar } from '@mui/material';
import { useEffect, useState } from 'react';
import { ensureNotificationPermission } from './notification-permission';

export function NotificationPermissionBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!('Notification' in window)) return;
    if (Notification.permission === 'default') setOpen(true);
  }, []);

  const handleAllow = async () => {
    await ensureNotificationPermission();
    setOpen(false);
  };

  const handleClose = () => setOpen(false);

  if (!open) return null;

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      message='Cho phép thông báo để nhận tin nhắn nền'
      action={<Button onClick={handleAllow}>Cho phép</Button>}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    />
  );
}
